import { REGIONS } from '@/modules/region/domain/region';

import { createUpsell } from '../upsell';

export const oEX9H0 = createUpsell({
  id: 'oEX9H0',
  desc: 'Upsell sequence for Pilates US test with different price for fast food',
  regions: [REGIONS.us],
  seq: [
    'upsell-12-month-pilates-us',
    'upsell-yoga-healthy-back',
    'upsell-digital-products-bundle',
    'downsale-digital-products-bundle',
  ],
});
